import { render, staticRenderFns } from "./SavedReplyMenu.vue?vue&type=template&id=6c7eb3ce&scoped=true"
import script from "./SavedReplyMenu.vue?vue&type=script&lang=js"
export * from "./SavedReplyMenu.vue?vue&type=script&lang=js"
import style0 from "./SavedReplyMenu.vue?vue&type=style&index=0&id=6c7eb3ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7eb3ce",
  null
  
)

export default component.exports